import DeviseLanguage from './deviseLanguage'

export default DeviseLanguage
